import './Login.css'
import LoginForm from "../../components/LoginForm/LoginForm";
// import { useNavigate } from "react-router-dom";
import { useEffect, useState } from 'react';

export default function Login({ updateClient, client }) {
  const [backgroundImage, setBackgroundImage] = useState(null);

  useEffect(() => {
    // Check if the background image is cached
    const cachedImage = localStorage.getItem('CPLoginBackgroundImage');
    if (cachedImage) {
        setBackgroundImage(cachedImage);
    } else {
        // Preload the background image and cache it
        const imageUrl = 'https://project-intake-assets.s3.ca-central-1.amazonaws.com/Login.jpg';
        const img = new Image();
        img.src = imageUrl;
        img.onload = () => {
            localStorage.setItem('CPLoginBackgroundImage', imageUrl);
            setBackgroundImage(imageUrl);
        };
    }
  }, []);

  return (
    <div className="Login" style={{ backgroundImage: `url(${backgroundImage})` }}>
      <div className='formContainer'>
        <LoginForm updateClient={updateClient}/>
      </div>
    </ div>
  );
}